
import Vue from 'vue'
import { required } from 'vuelidate/lib/validators'
import DeletePopup from '@/components/popup/DeletePopup.vue'
import { IManagingOrganization } from '@/types/user'
import { ModalIds } from '@/components/popup/modal-ids'
import Loader from '@/components/Loader.vue'

export default Vue.extend({
  name: 'ContractorOrganization',
  components: { Loader, DeletePopup },
  data () {
    return {
      ModalIds,
      loader: false,
      editSystemSite: '' as string | null | undefined,
      formData: {
        shortName: '',
        fullName: null,
        inn: '',
        legalAddress: '',
        postalAddress: '',
        email: '',
        phone: '',
        createdAt: '',
        updatedAt: '',
        deletedAt: ''
      } as IManagingOrganization,
      dirtyPhone: '',
      siteEnabled: false,
      errorMsg: {}
    }
  },
  computed: {
    selectContractor (): any {
      return this.getOrganization()
    },
    idSelectContractor (): number {
      return this.$store.state.profile.currentOrganization.id
    }
  },
  watch: {
    idSelectContractor (val) {
      if (val) {
        this.pullOrganization()
      }
    }
  },
  mounted () {
    this.getOrganization()
    this.pullOrganization()
  },
  methods: {
    pullOrganization () {
      this.loader = false
      this.formData = this.selectContractor
      this.dirtyPhone = this.selectContractor.contactPhone
      this.errorMsg = {}
    },
    getOrganization () {
      // @ts-ignore
      const index = this.$store.state.profile.contractors.findIndex((item) => item.id === this.idSelectContractor)
      // @ts-ignore
      return this.$store.state.profile.contractors[index]
    },
    async updateOrganization () {
      this.errorMsg = {}
      // this.$v.$touch()
      // if (this.$v.$error) {
      //   return
      // }
    }
  },
  validations: {
    formData: {
      shortName: {
        required
      },
      inn: {
        required,
        validation (val: string) {
          return /^(\d{10}|\d{12})$/.test(val)
        }
      }
    }
  }
})
